import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type Activity = {
  id: Scalars['String']['output'];
};

export type Alumni = {
  PILBoost: Scalars['Float']['output'];
  company: Company;
  firstName: Scalars['String']['output'];
  gradYear: Scalars['Int']['output'];
  jobRole: JobRole;
  lastInitial: Scalars['String']['output'];
  purpose?: Maybe<Purpose>;
  salaryBoost: Scalars['Int']['output'];
  subTrack: Subtrack;
};

export type AlumniPathsMba = {
  isVisible: Scalars['Boolean']['output'];
  texts: AlumniPathsMbaTexts;
};

export type AlumniPathsMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  texts: AlumniPathsMbaTextsInput;
};

export type AlumniPathsMbaTexts = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AlumniPathsMbaTextsInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AmplitudeConfig = {
  apiKey: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
};

export type AmplitudeConfigInput = {
  apiKey: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsMba = {
  isDataAvailable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  links: AnalyticsMbaLinks;
  texts: AnalyticsMbaTexts;
};

export type AnalyticsMbaInput = {
  isDataAvailable?: Scalars['Boolean']['input'];
  isVisible?: Scalars['Boolean']['input'];
  links: AnalyticsMbaLinksInput;
  texts: AnalyticsMbaTextsInput;
};

export type AnalyticsMbaLinks = {
  goToExamples: Link;
};

export type AnalyticsMbaLinksInput = {
  goToExamples: LinkInput;
};

export type AnalyticsMbaTexts = {
  alumniCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  loggedInDescription: Scalars['String']['output'];
  loggedInTitle: Scalars['String']['output'];
  programGraduates?: Maybe<TextBlock>;
  title: Scalars['String']['output'];
  tuition: Scalars['Int']['output'];
};

export type AnalyticsMbaTextsInput = {
  alumniCount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  loggedInDescription: Scalars['String']['input'];
  loggedInTitle: Scalars['String']['input'];
  programGraduates?: InputMaybe<TextBlockInput>;
  title: Scalars['String']['input'];
  tuition: Scalars['Int']['input'];
};

export type AppConfigMbaInput = {
  assets: AssetsInput;
  featureFlags: FeatureFlagsInput;
  programType: Scalars['String']['input'];
  sections: SectionsMbaInput;
  theme: ThemeInput;
  university: UniversityInput;
  universityWebsiteUrl: Scalars['String']['input'];
};

export type AppConfigToolkitMba = {
  EMProgramId: Scalars['String']['output'];
  assets: Assets;
  featureFlags: FeatureFlags;
  programType: Scalars['String']['output'];
  sections: SectionsMba;
  theme: Theme;
  toolkitId: Scalars['String']['output'];
  university: University;
  universityWebsiteUrl: Scalars['String']['output'];
};

export type ApplyMba = {
  applyMode: ApplyMode;
  isVisible: Scalars['Boolean']['output'];
  links: ApplyMbaLinks;
  texts: ApplyMbaTexts;
};

export type ApplyMbaInput = {
  applyMode: ApplyMode;
  isVisible?: Scalars['Boolean']['input'];
  links: ApplyMbaLinksInput;
  texts: ApplyMbaTextsInput;
};

export type ApplyMbaLinks = {
  apply?: Maybe<Link>;
  applyForm?: Maybe<Link>;
};

export type ApplyMbaLinksInput = {
  apply?: InputMaybe<LinkInput>;
  applyForm?: InputMaybe<LinkInput>;
};

export type ApplyMbaTexts = {
  description: Scalars['String']['output'];
  form?: Maybe<ContactFormTexts>;
  title: Scalars['String']['output'];
};

export type ApplyMbaTextsInput = {
  description: Scalars['String']['input'];
  form?: InputMaybe<ContactFormTextsInput>;
  title: Scalars['String']['input'];
};

export enum ApplyMode {
  Form = 'form',
  Link = 'link'
}

export type Assets = {
  background: Scalars['String']['output'];
  favicons: Favicons;
  logo: Scalars['String']['output'];
};

export type AssetsInput = {
  background: Scalars['String']['input'];
  favicons: FaviconsInput;
  logo: Scalars['String']['input'];
};

export type AuthZDirectiveCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
  not?: InputMaybe<AuthZRules>;
  or?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
};

export type AuthZDirectiveDeepCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
  id?: InputMaybe<AuthZRules>;
  not?: InputMaybe<AuthZDirectiveDeepCompositeRulesInput>;
  or?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
};

export enum AuthZRules {
  IsAdminUser = 'IsAdminUser',
  IsAuthenticated = 'IsAuthenticated',
  IsCmsUser = 'IsCMSUser',
  IsFileOwner = 'IsFileOwner',
  IsReadySetUser = 'IsReadySetUser',
  IsWebhookGatewayQuery = 'IsWebhookGatewayQuery'
}

export type CareerBoostMba = {
  isVisible: Scalars['Boolean']['output'];
  texts: CareerBoostMbaTexts;
};

export type CareerBoostMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  texts: CareerBoostMbaTextsInput;
};

export type CareerBoostMbaTexts = {
  title: Scalars['String']['output'];
};

export type CareerBoostMbaTextsInput = {
  title: Scalars['String']['input'];
};

export type Company = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CompareScore = {
  DSScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type ContactFormTexts = {
  placeholders?: Maybe<FormPlaceholders>;
};

export type ContactFormTextsInput = {
  placeholders?: InputMaybe<FormPlaceholdersInput>;
};

export type DataValueEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataValueEntityInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DatadogConfig = {
  applicationId: Scalars['String']['output'];
  clientToken: Scalars['String']['output'];
};

export type DatadogConfigInput = {
  applicationId: Scalars['String']['input'];
  clientToken: Scalars['String']['input'];
};

export type DeploymentConfig = {
  EMProgramId: Scalars['String']['output'];
  amplitude?: Maybe<AmplitudeConfig>;
  appName: Scalars['String']['output'];
  artifactGroupId: Scalars['String']['output'];
  baseName: Scalars['String']['output'];
  datadog?: Maybe<DatadogConfig>;
  emailSupport: Scalars['String']['output'];
  entranceUrl: Scalars['String']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<LinkedInConfig>;
  relativeRecordSetName: Scalars['String']['output'];
};

export type DeploymentConfigInput = {
  EMProgramId: Scalars['String']['input'];
  amplitude?: InputMaybe<AmplitudeConfigInput>;
  appName: Scalars['String']['input'];
  artifactGroupId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
  datadog?: InputMaybe<DatadogConfigInput>;
  emailSupport: Scalars['String']['input'];
  entranceUrl?: Scalars['String']['input'];
  linkedIn?: InputMaybe<LinkedInConfigInput>;
  relativeRecordSetName: Scalars['String']['input'];
};

export enum DeploymentStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'inProgress',
  Pending = 'pending'
}

export type DsPilScoreQueryInput = {
  EMProgramId: Scalars['String']['input'];
  currentLocationId: Scalars['String']['input'];
  destinationLocationId: Scalars['String']['input'];
  jobRoleId: Scalars['String']['input'];
  majorId?: InputMaybe<Scalars['String']['input']>;
  purposeId: Scalars['String']['input'];
  subTrackId: Scalars['String']['input'];
  years?: Scalars['Int']['input'];
};

export type EmCourse = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  program: Program;
  skills: Array<Skill>;
};

export type Favicons = {
  androidChrome192: Scalars['String']['output'];
  androidChrome256: Scalars['String']['output'];
  appleTouchIcon: Scalars['String']['output'];
  favicon: Scalars['String']['output'];
  favicon16: Scalars['String']['output'];
  favicon32: Scalars['String']['output'];
  mStile150: Scalars['String']['output'];
  safariPinnedTab: Scalars['String']['output'];
};

export type FaviconsInput = {
  androidChrome192: Scalars['String']['input'];
  androidChrome256: Scalars['String']['input'];
  appleTouchIcon: Scalars['String']['input'];
  favicon: Scalars['String']['input'];
  favicon16: Scalars['String']['input'];
  favicon32: Scalars['String']['input'];
  mStile150: Scalars['String']['input'];
  safariPinnedTab: Scalars['String']['input'];
};

export type FeatureFlags = {
  guestWithAuthorizedPermissions: Scalars['Boolean']['output'];
};

export type FeatureFlagsInput = {
  guestWithAuthorizedPermissions?: Scalars['Boolean']['input'];
};

export type FinancialBoostMba = {
  isVisible: Scalars['Boolean']['output'];
  texts: FinancialBoostMbaTexts;
};

export type FinancialBoostMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  texts: FinancialBoostMbaTextsInput;
};

export type FinancialBoostMbaTexts = {
  title: Scalars['String']['output'];
};

export type FinancialBoostMbaTextsInput = {
  title: Scalars['String']['input'];
};

export type FooterMba = {
  isVisible: Scalars['Boolean']['output'];
};

export type FormPlaceholders = {
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type FormPlaceholdersInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GetToolkitByParamsInput = {
  emProgramId: Scalars['String']['input'];
};

export type HeaderMba = {
  isVisible: Scalars['Boolean']['output'];
  links: HeaderMbaLinks;
};

export type HeaderMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  links: HeaderMbaLinksInput;
};

export type HeaderMbaLinks = {
  apply: Link;
};

export type HeaderMbaLinksInput = {
  apply: LinkInput;
};

export type HistoryLog = {
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deploymentStatus: DeploymentStatus;
  state: Scalars['JSONObject']['output'];
  toolkitId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type IntroductionMba = {
  dataValues: IntroductionMbaDataValues;
  isVisible: Scalars['Boolean']['output'];
  links: IntroductionMbaLinks;
  texts: IntroductionMbaTexts;
};

export type IntroductionMbaDataValues = {
  initial: IntroductionMbaInitialValues;
  purposes: Array<DataValueEntity>;
  subTracks: Array<DataValueEntity>;
};

export type IntroductionMbaDataValuesInput = {
  initial: IntroductionMbaInitialValuesInput;
  purposes: Array<DataValueEntityInput>;
  subTracks: Array<DataValueEntityInput>;
};

export type IntroductionMbaInitialValues = {
  currentLocation: LocationDataValue;
  destinationLocation: LocationDataValue;
  jobRole: JobRoleDataValue;
  major: MajorDataValue;
  purpose: PurposeDataValue;
  subTrack: SubtrackDataValue;
  years: Scalars['Float']['output'];
};

export type IntroductionMbaInitialValuesInput = {
  currentLocation: DataValueEntityInput;
  destinationLocation: DataValueEntityInput;
  jobRole: DataValueEntityInput;
  major: DataValueEntityInput;
  purpose: DataValueEntityInput;
  subTrack: DataValueEntityInput;
  years: Scalars['Float']['input'];
};

export type IntroductionMbaInput = {
  dataValues: IntroductionMbaDataValuesInput;
  isVisible?: Scalars['Boolean']['input'];
  links: IntroductionMbaLinksInput;
  texts: IntroductionMbaTextsInput;
};

export type IntroductionMbaLinks = {
  getApplicationStarted: Link;
  getPersonalizedPrediction: Link;
};

export type IntroductionMbaLinksInput = {
  getApplicationStarted: LinkInput;
  getPersonalizedPrediction: LinkInput;
};

export type IntroductionMbaTexts = {
  description: Scalars['String']['output'];
  loggedInDescription: Scalars['String']['output'];
  loggedInTitle: Scalars['String']['output'];
  postIconTitle?: Maybe<Scalars['String']['output']>;
  preIconTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type IntroductionMbaTextsInput = {
  description: Scalars['String']['input'];
  loggedInDescription: Scalars['String']['input'];
  loggedInTitle: Scalars['String']['input'];
  postIconTitle?: InputMaybe<Scalars['String']['input']>;
  preIconTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type JobRole = {
  activities: Array<Activity>;
  description?: Maybe<Scalars['String']['output']>;
  hardSkills: Array<Skill>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  skills: Array<Skill>;
  softSkills: Array<Skill>;
  standardJobTitles: Array<Scalars['String']['output']>;
  subtrack?: Maybe<Subtrack>;
};

export type JobRoleDataValue = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Link = {
  conversionId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkInput = {
  conversionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkedInConfig = {
  conversionId?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['String']['output'];
};

export type LinkedInConfigInput = {
  partnerId: Scalars['String']['input'];
};

export type Location = {
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  msaId: Scalars['String']['output'];
  /** Computed value combining city name and state name */
  name: Scalars['String']['output'];
  state: State;
};

export type LocationDataValue = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Major = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MajorDataValue = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  applyButtonEvent: Scalars['Boolean']['output'];
  createOrUpdateMbaToolkit: Toolkit;
  destroyToolkit: Toolkit;
  sendReadysetApplyMessage: Scalars['Boolean']['output'];
  setWebhookConfigs: Toolkit;
  updateToolkits: Array<Toolkit>;
};


export type MutationCreateOrUpdateMbaToolkitArgs = {
  input: ToolkitMbaInput;
};


export type MutationDestroyToolkitArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendReadysetApplyMessageArgs = {
  input: SendMessageInput;
};


export type MutationSetWebhookConfigsArgs = {
  toolkitId: Scalars['String']['input'];
  webhookConfigs: Array<WebhookConfigInput>;
};


export type MutationUpdateToolkitsArgs = {
  artifactGroupId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type OverviewMba = {
  isVisible: Scalars['Boolean']['output'];
  texts: OverviewMbaTexts;
};

export type OverviewMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  texts: OverviewMbaTextsInput;
};

export type OverviewMbaTexts = {
  description: Scalars['String']['output'];
  loggedInDescription: Scalars['String']['output'];
  loggedInTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  toolkit?: Maybe<TextBlockDescriptionOnly>;
};

export type OverviewMbaTextsInput = {
  description: Scalars['String']['input'];
  loggedInDescription: Scalars['String']['input'];
  loggedInTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  toolkit?: InputMaybe<TextBlockDescriptionOnlyInput>;
};

export type PilScore = {
  currentLocation: Location;
  destinationLocation: Location;
  jobRole: JobRole;
  major?: Maybe<Major>;
  postPIL: Scalars['Float']['output'];
  program: Program;
  purpose: Purpose;
  subTrack: Subtrack;
  years: Scalars['Int']['output'];
};

export type PilScoreQueryInput = {
  currentLocationId: Scalars['String']['input'];
  destinationLocationId: Scalars['String']['input'];
  jobRoleId: Scalars['String']['input'];
  majorId?: InputMaybe<Scalars['String']['input']>;
  purposeId: Scalars['String']['input'];
  subTrackId: Scalars['String']['input'];
  years?: Scalars['Int']['input'];
};

export type Program = {
  alumni: Array<Alumni>;
  alumniCount: Scalars['Int']['output'];
  destinationLocationCount: Scalars['Int']['output'];
  emCourses: Array<EmCourse>;
  employmentRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  programType: ProgramType;
  salaryBoost: Scalars['String']['output'];
  skills: Array<Skill>;
  skillsCount: Scalars['Int']['output'];
  subTrackCount: Scalars['Int']['output'];
  topStatesByCount: Array<TopStateByCount>;
  topStatesBySalary: Array<TopStateBySalary>;
  topSubTracksByCount: Array<TopSubTrackByCount>;
  tuition: Scalars['String']['output'];
};


export type ProgramAlumniArgs = {
  PILBoost?: InputMaybe<Scalars['Float']['input']>;
  subTrackId?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramBase = {
  id: Scalars['String']['input'];
};

export type ProgramType = {
  id: Scalars['String']['output'];
};

export type Purpose = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PurposeDataValue = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  PILScoreByQuery: PilScore;
  appConfig: AppConfigToolkitMba;
  autocompleteLocation: Array<Location>;
  company: Company;
  emCourse: EmCourse;
  getToolkit: Toolkit;
  getToolkits: Array<Toolkit>;
  getToolkitsByParams: Array<Toolkit>;
  historyLogs: Array<HistoryLog>;
  jobRole: JobRole;
  jobRolesWithSkills: Array<JobRole>;
  major: Major;
  program: Program;
  programs: Array<Program>;
  purpose: Purpose;
  purposes: Array<Purpose>;
  service: ServiceInfo;
  skill: Skill;
  state: State;
  stateByName: StateByName;
  subTrack: Subtrack;
  subTracks: Array<Subtrack>;
  subTracksByProgram: Array<Subtrack>;
  suggestCompanies: Array<Company>;
  suggestJobRolesWithSubtracks: Array<JobRole>;
  suggestMajors: Array<Major>;
  suggestSkills: Array<Skill>;
  suggestSubTracks: Array<Subtrack>;
};


export type QueryPilScoreByQueryArgs = {
  query: PilScoreQueryInput;
  savePredictionFilters?: Scalars['Boolean']['input'];
};


export type QueryAppConfigArgs = {
  toolkitId: Scalars['String']['input'];
};


export type QueryAutocompleteLocationArgs = {
  query: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmCourseArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetToolkitArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetToolkitsByParamsArgs = {
  input: GetToolkitByParamsInput;
};


export type QueryHistoryLogsArgs = {
  toolkitId: Scalars['String']['input'];
};


export type QueryJobRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryJobRolesWithSkillsArgs = {
  subtrackId: Scalars['String']['input'];
};


export type QueryMajorArgs = {
  id: Scalars['String']['input'];
};


export type QueryProgramArgs = {
  id: Scalars['String']['input'];
};


export type QueryPurposeArgs = {
  id: Scalars['String']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['String']['input'];
};


export type QueryStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryStateByNameArgs = {
  name: Scalars['String']['input'];
};


export type QuerySubTrackArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubTracksByProgramArgs = {
  EMProgramId: Scalars['String']['input'];
};


export type QuerySuggestCompaniesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestJobRolesWithSubtracksArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMajorsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestSkillsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestSubTracksArgs = {
  query: Scalars['String']['input'];
};

export type Salary = {
  jobRoles: Array<JobRole>;
  salary: Scalars['Int']['output'];
  salaryBoost: Scalars['Int']['output'];
  state: State;
};

export type Score = {
  score: Scalars['Float']['output'];
};

export type SectionInput = {
  isVisible?: Scalars['Boolean']['input'];
};

export type SectionsMba = {
  alumniPaths: AlumniPathsMba;
  analytics: AnalyticsMba;
  apply: ApplyMba;
  careerBoost: CareerBoostMba;
  financialBoost: FinancialBoostMba;
  footer: FooterMba;
  header: HeaderMba;
  introduction: IntroductionMba;
  overview: OverviewMba;
  skillsetBoost: SkillsetBoostMba;
};

export type SectionsMbaInput = {
  alumniPaths: AlumniPathsMbaInput;
  analytics: AnalyticsMbaInput;
  apply: ApplyMbaInput;
  careerBoost: CareerBoostMbaInput;
  financialBoost: FinancialBoostMbaInput;
  footer: SectionInput;
  header: HeaderMbaInput;
  introduction: IntroductionMbaInput;
  overview: OverviewMbaInput;
  skillsetBoost: SkillsetBoostMbaInput;
};

export type SendMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceInfo = {
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Skill = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SkillsetBoostMba = {
  isVisible: Scalars['Boolean']['output'];
  texts: SkillsetBoostMbaTexts;
};

export type SkillsetBoostMbaInput = {
  isVisible?: Scalars['Boolean']['input'];
  texts: SkillsetBoostMbaTextsInput;
};

export type SkillsetBoostMbaTexts = {
  title: Scalars['String']['output'];
};

export type SkillsetBoostMbaTextsInput = {
  title: Scalars['String']['input'];
};

export type State = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StateByName = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Subtrack = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  salary: Salary;
};

export type SubtrackDataValue = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TextBlock = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TextBlockDescriptionOnly = {
  description: Scalars['String']['output'];
};

export type TextBlockDescriptionOnlyInput = {
  description: Scalars['String']['input'];
};

export type TextBlockInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Theme = {
  blueGradient: Scalars['String']['output'];
  confirmationColor: Scalars['String']['output'];
  contourColor: Scalars['String']['output'];
  errorColor: Scalars['String']['output'];
  orangeGradient: Scalars['String']['output'];
  primaryAccentColor: Scalars['String']['output'];
  primaryBackgroundColor: Scalars['String']['output'];
  primaryBoxShadow: Scalars['String']['output'];
  primaryDataColor: Scalars['String']['output'];
  secondaryAccentColor: Scalars['String']['output'];
  secondaryBackgroundColor: Scalars['String']['output'];
  secondaryDataColor: Scalars['String']['output'];
  skinTone: Scalars['String']['output'];
};

export type ThemeInput = {
  blueGradient: Scalars['String']['input'];
  confirmationColor: Scalars['String']['input'];
  contourColor: Scalars['String']['input'];
  errorColor: Scalars['String']['input'];
  orangeGradient: Scalars['String']['input'];
  primaryAccentColor: Scalars['String']['input'];
  primaryBackgroundColor: Scalars['String']['input'];
  primaryBoxShadow: Scalars['String']['input'];
  primaryDataColor: Scalars['String']['input'];
  secondaryAccentColor: Scalars['String']['input'];
  secondaryBackgroundColor: Scalars['String']['input'];
  secondaryDataColor: Scalars['String']['input'];
  skinTone: Scalars['String']['input'];
};

export type Toolkit = {
  _id: Scalars['String']['output'];
  appConfig: AppConfigToolkitMba;
  createdAt: Scalars['DateTime']['output'];
  deploymentConfig: DeploymentConfig;
  isEmbeddable?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  webhookConfigs: Array<WebhookConfig>;
};

export type ToolkitMbaInput = {
  appConfig: AppConfigMbaInput;
  deploymentConfig: DeploymentConfigInput;
  isEmbeddable?: Scalars['Boolean']['input'];
};

export type TopStateByCount = {
  alumniCount: Scalars['Int']['output'];
  state: State;
};

export type TopStateBySalary = {
  salary: Scalars['String']['output'];
  state: State;
};

export type TopSubTrackByCount = {
  alumniCount: Scalars['Int']['output'];
  subTrack: Subtrack;
};

export type University = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UniversityInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type User = {
  id: Scalars['String']['output'];
};

export type WebhookConfig = {
  _id: Scalars['String']['output'];
  apiSecret: Scalars['String']['output'];
  apiUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WebhookConfigInput = {
  apiSecret: Scalars['String']['input'];
  apiUrl: Scalars['String']['input'];
};

export type ApplyButtonEventMutationVariables = Exact<{ [key: string]: never; }>;


export type ApplyButtonEventMutation = { applyButtonEvent: boolean };

export type ProgramApplyMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type ProgramApplyMutation = { sendReadysetApplyMessage: boolean };

export type PilScoreByQueryQueryVariables = Exact<{
  query: PilScoreQueryInput;
  savePredictionFilters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PilScoreByQueryQuery = { PILScoreByQuery: { years: number, postPIL: number, jobRole: { id: string, name: string }, currentLocation: { id: string, name: string }, destinationLocation: { id: string, name: string }, subTrack: { id: string, name: string, salary: { salary: number, salaryBoost: number } }, purpose: { id: string, name: string }, major?: { id: string, name: string } | null } };

export type AppConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AppConfigQuery = { appConfig: { EMProgramId: string, universityWebsiteUrl: string, programType: string, sections: { header: { isVisible: boolean, links: { apply: { url?: string | null, text: string, conversionId?: string | null } } }, introduction: { isVisible: boolean, texts: { description: string, title: string, loggedInTitle: string, loggedInDescription: string, preIconTitle?: string | null, postIconTitle?: string | null }, links: { getPersonalizedPrediction: { url?: string | null, text: string, conversionId?: string | null }, getApplicationStarted: { url?: string | null, text: string, conversionId?: string | null } }, dataValues: { subTracks: Array<{ id: string, name: string }>, purposes: Array<{ id: string, name: string }>, initial: { years: number, major: { id: string, name: string }, subTrack: { id: string, name: string }, jobRole: { id: string, name: string }, purpose: { id: string, name: string }, currentLocation: { id: string, name: string }, destinationLocation: { id: string, name: string } } } }, overview: { isVisible: boolean, texts: { description: string, title: string, loggedInTitle: string, loggedInDescription: string, toolkit?: { description: string } | null } }, analytics: { isVisible: boolean, isDataAvailable: boolean, texts: { title: string, description: string, loggedInTitle: string, loggedInDescription: string, alumniCount: number, tuition: number, programGraduates?: { description: string, title: string } | null }, links: { goToExamples: { url?: string | null, text: string, conversionId?: string | null } } }, alumniPaths: { isVisible: boolean, texts: { title: string, description: string } }, careerBoost: { isVisible: boolean, texts: { title: string } }, financialBoost: { isVisible: boolean, texts: { title: string } }, skillsetBoost: { isVisible: boolean, texts: { title: string } }, apply: { isVisible: boolean, applyMode: ApplyMode, texts: { title: string, description: string, form?: { placeholders?: { name: string, email: string, phone: string, message: string } | null } | null }, links: { apply?: { url?: string | null, text: string, conversionId?: string | null } | null } }, footer: { isVisible: boolean } }, assets: { logo: string, background: string, favicons: { favicon: string, favicon16: string, favicon32: string, mStile150: string, androidChrome192: string, androidChrome256: string, appleTouchIcon: string, safariPinnedTab: string } }, university: { id: string, name: string }, featureFlags: { guestWithAuthorizedPermissions: boolean }, theme: { skinTone: string, errorColor: string, contourColor: string, blueGradient: string, orangeGradient: string, primaryDataColor: string, primaryBoxShadow: string, confirmationColor: string, primaryAccentColor: string, secondaryDataColor: string, secondaryAccentColor: string, primaryBackgroundColor: string, secondaryBackgroundColor: string } } };

export type LinkFragment = { url?: string | null, text: string, conversionId?: string | null };

export type TextBlockDescriptionFragment = { description: string };

export type TextBlockFragment = { description: string, title: string };

export type JobRolesWithSkillsQueryVariables = Exact<{
  subTrackId: Scalars['String']['input'];
}>;


export type JobRolesWithSkillsQuery = { jobRolesWithSkills: Array<{ id: string, name: string, skills: Array<{ id: string, name: string }> }> };

export type ProgramQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProgramQuery = { program: { id: string, name: string, alumniCount: number, destinationLocationCount: number, employmentRate: number, subTrackCount: number, salaryBoost: string, topSubTracksByCount: Array<{ alumniCount: number, subTrack: { id: string, name: string } }>, topStatesBySalary: Array<{ salary: string, state: { id: string } }>, topStatesByCount: Array<{ alumniCount: number, state: { id: string, name: string } }> } };

export type ProgramAlumniQueryVariables = Exact<{
  id: Scalars['String']['input'];
  subTrackId: Scalars['String']['input'];
}>;


export type ProgramAlumniQuery = { program: { id: string, alumni: Array<{ lastInitial: string, firstName: string, PILBoost: number, salaryBoost: number, gradYear: number, jobRole: { id: string, name: string }, company: { id: string, name: string }, purpose?: { id: string, name: string } | null, subTrack: { id: string, name: string } }> } };

export type ProgramSkillsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProgramSkillsQuery = { program: { id: string, name: string, skillsCount: number, skills: Array<{ id: string, name: string }> } };

export type ProgramCoursesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProgramCoursesQuery = { program: { id: string, emCourses: Array<{ id: string, name: string, skills: Array<{ id: string, name: string }> }> } };

export type SearchJobRoleQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchJobRoleQuery = { suggestJobRolesWithSubtracks: Array<{ id: string, name: string }> };

export type SearchLocationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchLocationQuery = { autocompleteLocation: Array<{ id: string, name: string }> };

export type SearchMajorQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchMajorQuery = { suggestMajors: Array<{ id: string, name: string }> };

export const LinkFragmentDoc = gql`
    fragment Link on Link {
  url
  text
  conversionId
}
    `;
export const TextBlockDescriptionFragmentDoc = gql`
    fragment TextBlockDescription on TextBlockDescriptionOnly {
  description
}
    `;
export const TextBlockFragmentDoc = gql`
    fragment TextBlock on TextBlock {
  description
  title
}
    `;
export const ApplyButtonEventDocument = gql`
    mutation applyButtonEvent {
  applyButtonEvent
}
    `;
export type ApplyButtonEventMutationFn = Apollo.MutationFunction<ApplyButtonEventMutation, ApplyButtonEventMutationVariables>;

/**
 * __useApplyButtonEventMutation__
 *
 * To run a mutation, you first call `useApplyButtonEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyButtonEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyButtonEventMutation, { data, loading, error }] = useApplyButtonEventMutation({
 *   variables: {
 *   },
 * });
 */
export function useApplyButtonEventMutation(baseOptions?: Apollo.MutationHookOptions<ApplyButtonEventMutation, ApplyButtonEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyButtonEventMutation, ApplyButtonEventMutationVariables>(ApplyButtonEventDocument, options);
      }
export type ApplyButtonEventMutationHookResult = ReturnType<typeof useApplyButtonEventMutation>;
export type ApplyButtonEventMutationResult = Apollo.MutationResult<ApplyButtonEventMutation>;
export type ApplyButtonEventMutationOptions = Apollo.BaseMutationOptions<ApplyButtonEventMutation, ApplyButtonEventMutationVariables>;
export const ProgramApplyDocument = gql`
    mutation programApply($input: SendMessageInput!) {
  sendReadysetApplyMessage(input: $input)
}
    `;
export type ProgramApplyMutationFn = Apollo.MutationFunction<ProgramApplyMutation, ProgramApplyMutationVariables>;

/**
 * __useProgramApplyMutation__
 *
 * To run a mutation, you first call `useProgramApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programApplyMutation, { data, loading, error }] = useProgramApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProgramApplyMutation(baseOptions?: Apollo.MutationHookOptions<ProgramApplyMutation, ProgramApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramApplyMutation, ProgramApplyMutationVariables>(ProgramApplyDocument, options);
      }
export type ProgramApplyMutationHookResult = ReturnType<typeof useProgramApplyMutation>;
export type ProgramApplyMutationResult = Apollo.MutationResult<ProgramApplyMutation>;
export type ProgramApplyMutationOptions = Apollo.BaseMutationOptions<ProgramApplyMutation, ProgramApplyMutationVariables>;
export const PilScoreByQueryDocument = gql`
    query PILScoreByQuery($query: PILScoreQueryInput!, $savePredictionFilters: Boolean) {
  PILScoreByQuery(query: $query, savePredictionFilters: $savePredictionFilters) {
    years
    jobRole {
      id
      name
    }
    currentLocation {
      id
      name
    }
    destinationLocation {
      id
      name
    }
    postPIL
    subTrack {
      id
      name
      salary {
        salary
        salaryBoost
      }
    }
    purpose {
      id
      name
    }
    major {
      id
      name
    }
  }
}
    `;

/**
 * __usePilScoreByQueryQuery__
 *
 * To run a query within a React component, call `usePilScoreByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilScoreByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilScoreByQueryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      savePredictionFilters: // value for 'savePredictionFilters'
 *   },
 * });
 */
export function usePilScoreByQueryQuery(baseOptions: Apollo.QueryHookOptions<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>(PilScoreByQueryDocument, options);
      }
export function usePilScoreByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>(PilScoreByQueryDocument, options);
        }
export function usePilScoreByQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>(PilScoreByQueryDocument, options);
        }
export type PilScoreByQueryQueryHookResult = ReturnType<typeof usePilScoreByQueryQuery>;
export type PilScoreByQueryLazyQueryHookResult = ReturnType<typeof usePilScoreByQueryLazyQuery>;
export type PilScoreByQuerySuspenseQueryHookResult = ReturnType<typeof usePilScoreByQuerySuspenseQuery>;
export type PilScoreByQueryQueryResult = Apollo.QueryResult<PilScoreByQueryQuery, PilScoreByQueryQueryVariables>;
export const AppConfigDocument = gql`
    query appConfig($id: String!) {
  appConfig(toolkitId: $id) {
    sections {
      header {
        isVisible
        links {
          apply {
            ...Link
          }
        }
      }
      introduction {
        isVisible
        texts {
          description
          title
          loggedInTitle
          loggedInDescription
          preIconTitle
          postIconTitle
        }
        links {
          getPersonalizedPrediction {
            ...Link
          }
          getApplicationStarted {
            ...Link
          }
        }
        dataValues {
          subTracks {
            id
            name
          }
          purposes {
            id
            name
          }
          initial {
            years
            major {
              id
              name
            }
            subTrack {
              id
              name
            }
            jobRole {
              id
              name
            }
            purpose {
              id
              name
            }
            currentLocation {
              id
              name
            }
            destinationLocation {
              id
              name
            }
          }
        }
      }
      overview {
        isVisible
        texts {
          description
          title
          loggedInTitle
          loggedInDescription
          toolkit {
            ...TextBlockDescription
          }
        }
      }
      analytics {
        isVisible
        isDataAvailable
        texts {
          title
          description
          loggedInTitle
          loggedInDescription
          programGraduates {
            ...TextBlock
          }
          alumniCount
          tuition
        }
        links {
          goToExamples {
            ...Link
          }
        }
      }
      alumniPaths {
        isVisible
        texts {
          title
          description
        }
      }
      careerBoost {
        isVisible
        texts {
          title
        }
      }
      financialBoost {
        isVisible
        texts {
          title
        }
      }
      skillsetBoost {
        isVisible
        texts {
          title
        }
      }
      apply {
        isVisible
        texts {
          title
          description
          form {
            placeholders {
              name
              email
              phone
              message
            }
          }
        }
        links {
          apply {
            ...Link
          }
        }
        applyMode
      }
      footer {
        isVisible
      }
    }
    assets {
      logo
      background
      favicons {
        favicon
        favicon16
        favicon32
        mStile150
        androidChrome192
        androidChrome256
        appleTouchIcon
        safariPinnedTab
      }
    }
    EMProgramId
    university {
      id
      name
    }
    featureFlags {
      guestWithAuthorizedPermissions
    }
    universityWebsiteUrl
    programType
    theme {
      skinTone
      errorColor
      contourColor
      blueGradient
      orangeGradient
      primaryDataColor
      primaryBoxShadow
      confirmationColor
      primaryAccentColor
      secondaryDataColor
      secondaryAccentColor
      primaryBackgroundColor
      secondaryBackgroundColor
    }
  }
}
    ${LinkFragmentDoc}
${TextBlockDescriptionFragmentDoc}
${TextBlockFragmentDoc}`;

/**
 * __useAppConfigQuery__
 *
 * To run a query within a React component, call `useAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppConfigQuery(baseOptions: Apollo.QueryHookOptions<AppConfigQuery, AppConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppConfigQuery, AppConfigQueryVariables>(AppConfigDocument, options);
      }
export function useAppConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppConfigQuery, AppConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppConfigQuery, AppConfigQueryVariables>(AppConfigDocument, options);
        }
export function useAppConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppConfigQuery, AppConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppConfigQuery, AppConfigQueryVariables>(AppConfigDocument, options);
        }
export type AppConfigQueryHookResult = ReturnType<typeof useAppConfigQuery>;
export type AppConfigLazyQueryHookResult = ReturnType<typeof useAppConfigLazyQuery>;
export type AppConfigSuspenseQueryHookResult = ReturnType<typeof useAppConfigSuspenseQuery>;
export type AppConfigQueryResult = Apollo.QueryResult<AppConfigQuery, AppConfigQueryVariables>;
export const JobRolesWithSkillsDocument = gql`
    query jobRolesWithSkills($subTrackId: String!) {
  jobRolesWithSkills(subtrackId: $subTrackId) {
    id
    name
    skills {
      id
      name
    }
  }
}
    `;

/**
 * __useJobRolesWithSkillsQuery__
 *
 * To run a query within a React component, call `useJobRolesWithSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRolesWithSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRolesWithSkillsQuery({
 *   variables: {
 *      subTrackId: // value for 'subTrackId'
 *   },
 * });
 */
export function useJobRolesWithSkillsQuery(baseOptions: Apollo.QueryHookOptions<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>(JobRolesWithSkillsDocument, options);
      }
export function useJobRolesWithSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>(JobRolesWithSkillsDocument, options);
        }
export function useJobRolesWithSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>(JobRolesWithSkillsDocument, options);
        }
export type JobRolesWithSkillsQueryHookResult = ReturnType<typeof useJobRolesWithSkillsQuery>;
export type JobRolesWithSkillsLazyQueryHookResult = ReturnType<typeof useJobRolesWithSkillsLazyQuery>;
export type JobRolesWithSkillsSuspenseQueryHookResult = ReturnType<typeof useJobRolesWithSkillsSuspenseQuery>;
export type JobRolesWithSkillsQueryResult = Apollo.QueryResult<JobRolesWithSkillsQuery, JobRolesWithSkillsQueryVariables>;
export const ProgramDocument = gql`
    query program($id: String!) {
  program(id: $id) {
    id
    name
    alumniCount
    destinationLocationCount
    employmentRate
    subTrackCount
    salaryBoost
    topSubTracksByCount {
      alumniCount
      subTrack {
        id
        name
      }
    }
    topStatesBySalary {
      salary
      state {
        id
      }
    }
    topStatesByCount {
      alumniCount
      state {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProgramQuery__
 *
 * To run a query within a React component, call `useProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProgramQuery(baseOptions: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
      }
export function useProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export function useProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramSuspenseQueryHookResult = ReturnType<typeof useProgramSuspenseQuery>;
export type ProgramQueryResult = Apollo.QueryResult<ProgramQuery, ProgramQueryVariables>;
export const ProgramAlumniDocument = gql`
    query programAlumni($id: String!, $subTrackId: String!) {
  program(id: $id) {
    id
    alumni(subTrackId: $subTrackId) {
      lastInitial
      firstName
      PILBoost
      salaryBoost
      gradYear
      jobRole {
        id
        name
      }
      company {
        id
        name
      }
      purpose {
        id
        name
      }
      subTrack {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProgramAlumniQuery__
 *
 * To run a query within a React component, call `useProgramAlumniQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAlumniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAlumniQuery({
 *   variables: {
 *      id: // value for 'id'
 *      subTrackId: // value for 'subTrackId'
 *   },
 * });
 */
export function useProgramAlumniQuery(baseOptions: Apollo.QueryHookOptions<ProgramAlumniQuery, ProgramAlumniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramAlumniQuery, ProgramAlumniQueryVariables>(ProgramAlumniDocument, options);
      }
export function useProgramAlumniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramAlumniQuery, ProgramAlumniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramAlumniQuery, ProgramAlumniQueryVariables>(ProgramAlumniDocument, options);
        }
export function useProgramAlumniSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramAlumniQuery, ProgramAlumniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramAlumniQuery, ProgramAlumniQueryVariables>(ProgramAlumniDocument, options);
        }
export type ProgramAlumniQueryHookResult = ReturnType<typeof useProgramAlumniQuery>;
export type ProgramAlumniLazyQueryHookResult = ReturnType<typeof useProgramAlumniLazyQuery>;
export type ProgramAlumniSuspenseQueryHookResult = ReturnType<typeof useProgramAlumniSuspenseQuery>;
export type ProgramAlumniQueryResult = Apollo.QueryResult<ProgramAlumniQuery, ProgramAlumniQueryVariables>;
export const ProgramSkillsDocument = gql`
    query programSkills($id: String!) {
  program(id: $id) {
    id
    name
    skillsCount
    skills {
      id
      name
    }
  }
}
    `;

/**
 * __useProgramSkillsQuery__
 *
 * To run a query within a React component, call `useProgramSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramSkillsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProgramSkillsQuery(baseOptions: Apollo.QueryHookOptions<ProgramSkillsQuery, ProgramSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramSkillsQuery, ProgramSkillsQueryVariables>(ProgramSkillsDocument, options);
      }
export function useProgramSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramSkillsQuery, ProgramSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramSkillsQuery, ProgramSkillsQueryVariables>(ProgramSkillsDocument, options);
        }
export function useProgramSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramSkillsQuery, ProgramSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramSkillsQuery, ProgramSkillsQueryVariables>(ProgramSkillsDocument, options);
        }
export type ProgramSkillsQueryHookResult = ReturnType<typeof useProgramSkillsQuery>;
export type ProgramSkillsLazyQueryHookResult = ReturnType<typeof useProgramSkillsLazyQuery>;
export type ProgramSkillsSuspenseQueryHookResult = ReturnType<typeof useProgramSkillsSuspenseQuery>;
export type ProgramSkillsQueryResult = Apollo.QueryResult<ProgramSkillsQuery, ProgramSkillsQueryVariables>;
export const ProgramCoursesDocument = gql`
    query programCourses($id: String!) {
  program(id: $id) {
    id
    emCourses {
      id
      name
      skills {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProgramCoursesQuery__
 *
 * To run a query within a React component, call `useProgramCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramCoursesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProgramCoursesQuery(baseOptions: Apollo.QueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
      }
export function useProgramCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
        }
export function useProgramCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramCoursesQuery, ProgramCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramCoursesQuery, ProgramCoursesQueryVariables>(ProgramCoursesDocument, options);
        }
export type ProgramCoursesQueryHookResult = ReturnType<typeof useProgramCoursesQuery>;
export type ProgramCoursesLazyQueryHookResult = ReturnType<typeof useProgramCoursesLazyQuery>;
export type ProgramCoursesSuspenseQueryHookResult = ReturnType<typeof useProgramCoursesSuspenseQuery>;
export type ProgramCoursesQueryResult = Apollo.QueryResult<ProgramCoursesQuery, ProgramCoursesQueryVariables>;
export const SearchJobRoleDocument = gql`
    query searchJobRole($query: String!) {
  suggestJobRolesWithSubtracks(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSearchJobRoleQuery__
 *
 * To run a query within a React component, call `useSearchJobRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchJobRoleQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchJobRoleQuery(baseOptions: Apollo.QueryHookOptions<SearchJobRoleQuery, SearchJobRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchJobRoleQuery, SearchJobRoleQueryVariables>(SearchJobRoleDocument, options);
      }
export function useSearchJobRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchJobRoleQuery, SearchJobRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchJobRoleQuery, SearchJobRoleQueryVariables>(SearchJobRoleDocument, options);
        }
export function useSearchJobRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchJobRoleQuery, SearchJobRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchJobRoleQuery, SearchJobRoleQueryVariables>(SearchJobRoleDocument, options);
        }
export type SearchJobRoleQueryHookResult = ReturnType<typeof useSearchJobRoleQuery>;
export type SearchJobRoleLazyQueryHookResult = ReturnType<typeof useSearchJobRoleLazyQuery>;
export type SearchJobRoleSuspenseQueryHookResult = ReturnType<typeof useSearchJobRoleSuspenseQuery>;
export type SearchJobRoleQueryResult = Apollo.QueryResult<SearchJobRoleQuery, SearchJobRoleQueryVariables>;
export const SearchLocationDocument = gql`
    query searchLocation($query: String!) {
  autocompleteLocation(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSearchLocationQuery__
 *
 * To run a query within a React component, call `useSearchLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchLocationQuery(baseOptions: Apollo.QueryHookOptions<SearchLocationQuery, SearchLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationQuery, SearchLocationQueryVariables>(SearchLocationDocument, options);
      }
export function useSearchLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationQuery, SearchLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationQuery, SearchLocationQueryVariables>(SearchLocationDocument, options);
        }
export function useSearchLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchLocationQuery, SearchLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLocationQuery, SearchLocationQueryVariables>(SearchLocationDocument, options);
        }
export type SearchLocationQueryHookResult = ReturnType<typeof useSearchLocationQuery>;
export type SearchLocationLazyQueryHookResult = ReturnType<typeof useSearchLocationLazyQuery>;
export type SearchLocationSuspenseQueryHookResult = ReturnType<typeof useSearchLocationSuspenseQuery>;
export type SearchLocationQueryResult = Apollo.QueryResult<SearchLocationQuery, SearchLocationQueryVariables>;
export const SearchMajorDocument = gql`
    query searchMajor($query: String!) {
  suggestMajors(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSearchMajorQuery__
 *
 * To run a query within a React component, call `useSearchMajorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMajorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMajorQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchMajorQuery(baseOptions: Apollo.QueryHookOptions<SearchMajorQuery, SearchMajorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMajorQuery, SearchMajorQueryVariables>(SearchMajorDocument, options);
      }
export function useSearchMajorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMajorQuery, SearchMajorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMajorQuery, SearchMajorQueryVariables>(SearchMajorDocument, options);
        }
export function useSearchMajorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMajorQuery, SearchMajorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMajorQuery, SearchMajorQueryVariables>(SearchMajorDocument, options);
        }
export type SearchMajorQueryHookResult = ReturnType<typeof useSearchMajorQuery>;
export type SearchMajorLazyQueryHookResult = ReturnType<typeof useSearchMajorLazyQuery>;
export type SearchMajorSuspenseQueryHookResult = ReturnType<typeof useSearchMajorSuspenseQuery>;
export type SearchMajorQueryResult = Apollo.QueryResult<SearchMajorQuery, SearchMajorQueryVariables>;
export const namedOperations = {
  Query: {
    PILScoreByQuery: 'PILScoreByQuery',
    appConfig: 'appConfig',
    jobRolesWithSkills: 'jobRolesWithSkills',
    program: 'program',
    programAlumni: 'programAlumni',
    programSkills: 'programSkills',
    programCourses: 'programCourses',
    searchJobRole: 'searchJobRole',
    searchLocation: 'searchLocation',
    searchMajor: 'searchMajor'
  },
  Mutation: {
    applyButtonEvent: 'applyButtonEvent',
    programApply: 'programApply'
  },
  Fragment: {
    Link: 'Link',
    TextBlockDescription: 'TextBlockDescription',
    TextBlock: 'TextBlock'
  }
}